<template>
  <div class="main-layout">
    <CCollapseItem>
      <template slot="title-left"> 教职工信息管理 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="新增" @click="goto('')">
            <i class="iconfont icon-add"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>

      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        @edit="goto"
        @delete="pageDel"
        @showDetail="handleToDetail"
        v-loading="pageLoading"
      >
      </c-table>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/teacher";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import CForm from "@/components/CForm/index.vue";
let mPage = MPage({
  pagePath: "/account/base/teacher/listPage",
  pageDelPath: "/account/base/teacher/",
  pageDelsPath: "/account/base/teacher/delBatch",
  pageParams: {},
});
export default {
  mixins: [mPage],
  name: "",
  components: { CSearch, CTable, TableBtns, CForm },
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleToDetail(data) {
      let id = data.id;
      this.$router.push("/basic/teacherInfo/detail/" + id);
    },
    goto(data) {
      let id = data.id;
      if (id) {
        this.$router.push("/basic/teacherInfo/edit/" + id);
      } else {
        this.$router.push("/basic/teacherInfo/add");
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
  },
};
</script>
